import { DiscoveryView } from "@/components/discovery/DiscoveryView";

export function DiscoveryPage() {
  return <DiscoveryView />;
}
